export * from './appointment-infos-box.component';
